import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ClientPortalDashboardPage } from './pages/ClientPortalDashboardPage';
import { ClientPortalDeliveriesPage } from './pages/ClientPortalDeliveriesPage';
import { ClientPortalDeliveryPage } from './pages/ClientPortalDeliveryPage';
import { ClientPortalInvoicePage } from './pages/ClientPortalInvoicePage';
import { ClientPortalInvoicesPage } from './pages/ClientPortalInvoicesPage';
import { ClientPortalOrderPage } from './pages/ClientPortalOrderPage';
import { ClientPortalOrdersPage } from './pages/ClientPortalOrdersPage';
import { ContactSearchPage } from './pages/ContactSearchPage';
import { CostRefPage } from './pages/CostRefPage';
import { DashboardPage } from './pages/DashboardPage';
import { DeliveryListPage } from './pages/DeliveryListPage';
import { IntransitOrdersPage } from './pages/IntransitOrdersPage';
import { IntransitQuotationsPage } from './pages/IntransitQuotationsPage';
import { IntransitInternalPage } from './pages/IntransitInternalPage';
import { IntransitArrivingPage } from './pages/IntransitArrivingPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { OrderListPage } from './pages/OrderListPage';
import { PurchaseIssuesPage } from './pages/PurchaseIssuesPage';
import { ReportPage } from './pages/ReportPage';
import { VendorBillsPage } from './pages/VendorBillsPage';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppShell>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/client" element={<ClientPortalDashboardPage />} />
          <Route path="/client/orders" element={<ClientPortalOrdersPage />} />
          <Route path="/client/orders/*" element={<ClientPortalOrderPage />} />
          <Route path="/client/deliveries" element={<ClientPortalDeliveriesPage />} />
          <Route path="/client/deliveries/*" element={<ClientPortalDeliveryPage />} />
          <Route path="/client/invoices" element={<ClientPortalInvoicesPage />} />
          <Route path="/client/invoices/*" element={<ClientPortalInvoicePage />} />
          <Route path="/dashboard/deliveries" element={<DeliveryListPage />} />
          <Route path="/dashboard/purchases" element={<PurchaseIssuesPage />} />
          <Route path="/dashboard/vendor-bills" element={<VendorBillsPage />} />
          <Route path="/agent/po" element={<OrderListPage title="Purchase orders" kind="po" />} />
          <Route path="/agent/po/:orderId" element={<OrderDetailPage kind="po" />} />
          <Route path="/agent/so" element={<OrderListPage title="Sales orders" kind="so" />} />
          <Route path="/agent/so/:orderId" element={<OrderDetailPage kind="so" />} />
          <Route path="/agent/contacts" element={<ContactSearchPage />} />
          <Route path="/agent/costref-search" element={<CostRefPage />} />
          <Route path="/intransit/quotations" element={<IntransitQuotationsPage />} />
          <Route path="/intransit/internal" element={<IntransitInternalPage />} />
          <Route path="/intransit/arriving" element={<IntransitArrivingPage />} />
          <Route path="/intransit/:mode" element={<IntransitOrdersPage />} />
          <Route path="/reports/:report" element={<ReportPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}

export default App;
